module.exports = __webpack_public_path__ + "static/team-alexandra-0f3db4a851d547bcc60eaf6ad71b5f3f.jpg";